import styled from "@emotion/styled";
import ApexCharts from "react-apexcharts";
import { chartDataByItem, itemTonGraphData } from "./itemMockupData";

interface ChartDataProps {
  itemCode?: string;
  mode?: "chart" | "point"; // 👈 구분을 위한 props
}

export const AnalysisPressChart = ({ itemCode, mode = "chart" }: ChartDataProps) => {
  const chartData = itemCode ? chartDataByItem[itemCode] : null;
  const pointData = itemCode ? itemTonGraphData[itemCode] : null;
  const defaultData = new Array(24).fill(0);

  const series =
    mode === "chart"
      ? [
          {
            name: "UPH (Line)",
            type: "line",
            data: chartData?.line ?? defaultData,
          },
          {
            name: "생산량 (Bar)",
            type: "bar",
            data: chartData?.bar ?? defaultData,
          },
        ]
      : [
          {
            name: "토탈 라인",
            type: "line",
            data: pointData?.line ?? defaultData,
          },
          {
            name: "Total Point",
            type: "scatter",
            data: pointData?.point
              ? [{ x: pointData.categories[13], y: pointData.point }]
              : [{ x: "12-13", y: 0 }],
          },
        ];

  const yaxis =
    mode === "chart"
      ? [
          {
            axisTicks: { show: true },
            axisBorder: { show: true, color: "#008FFB" },
            labels: { style: { colors: "#008FFB" } },
            title: {
              text: "UPH",
              style: { color: "#008FFB" },
            },
          },
          {
            opposite: true,
            axisTicks: { show: true },
            axisBorder: { show: true, color: "#00E396" },
            labels: { style: { colors: "#00E396" } },
            title: {
              text: "생산량",
              style: { color: "#00E396" },
            },
          },
        ]
      : [
          {
            axisTicks: { show: true },
            axisBorder: { show: true, color: "#FEB019" },
            labels: { style: { colors: "#FEB019" } },
            title: {
              text: "생산량 (ton)",
              style: { color: "#FEB019" },
            },
          },
        ];

  const xaxisCategories =
    pointData?.categories ??
    chartData?.line?.map(
      (_, i) => `${String(i).padStart(2, "0")}-${String(i + 1).padStart(2, "0")}`,
    ) ??
    [];

  const options = {
    chart: {
      height: 350,
      type: "line" as const,
      stacked: false,
    },
    dataLabels: { enabled: false },
    stroke: { width: [2, 0] },
    xaxis: {
      categories: xaxisCategories,
    },
    yaxis,
  };

  return (
    <Container>
      {series.length > 0 ? (
        <ApexCharts options={options} series={series} type="line" height={350} />
      ) : (
        <div>그래프를 표시할 수 없습니다 (데이터 없음).</div>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 70%;
`;
